import * as React from "react";
const HeadingOne = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7 7H6v5h7V7h-1V6h3v1h-1v11h1v1h-3v-1h1v-5H6v5h1v1H4v-1h1V7H4V6h3v1Zm11 5a1 1 0 0 1 1 1v5h1v1h-3v-1h1v-5h-1v-1h1Z" }));
HeadingOne.displayName = "HeadingOne";
var HeadingOne_default = HeadingOne;
export {
  HeadingOne_default as default
};
